import $ from 'jquery';
import init from './init.js';

/* -----------------------------------------------------------------
* Ready
----------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const $loader = $('.c-loading');

  if ($loader[0]) {
    $('html,body').animate({ scrollTop: 0, }, '1');
  }

  init.init();
});
